import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_TIMESHEET_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeTimesheetListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';

const retrieveTimesheetListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_TIMESHEET_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_TIMESHEET_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ timesheetLoader: true })),
        iif(
          () => body?.pageSize <= 100,
          of(setListConfigAction({ timesheet: body })),
          EMPTY
        ),
        defer(() =>
          from(
            request({ path: `timesheet/list`, method: httpMethods.POST, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return {
                total: p?.total,
                result: [...p?.result, ...filler],
                amount: p?.amount,
              };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_TIMESHEET_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeTimesheetListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_TIMESHEET_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ timesheetLoader: false }))
      );
    })
  );

export default retrieveTimesheetListEpic;
